import { Grid, Icon, IconButton, InputAdornment, Tooltip } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDInput from "components/Basics/MDInput";
import MDTypography from "components/Basics/MDTypography";
import { useEffect, useState } from "react";
import MDButton from "components/Basics/MDButton";
import { t } from "i18next";
import MappingDialog from "./components/MappingDialog";
import { useDispatch } from "react-redux";
import { queryDictionaries } from "helpers/dictionary";

const InputMapping = ({
	label,
	disabled = false,
	value,
	onChange,
	item = {},
	path = "",
	listOfApis = [],
	error,
	...rest
}) => {
	const config = item.config || {
		dictionaries: null,
		dictionariesInput: [],
		dictionariesOutput: []
	};

	const dispatch = useDispatch();

	const [openDialog, setOpenDialog] = useState(false);

	const [inputDictionaries, setInputDictionaries] = useState({});
	const [outputDictionaries, setOutputDictionaries] = useState({});

	const setupDictionaries = async () => {
		const inputDictionariesList = await queryDictionaries(dispatch, config.dictionariesInput);
		const outputDictionariesList = await queryDictionaries(dispatch, config.dictionariesOutput);

		setInputDictionaries(inputDictionariesList);
		setOutputDictionaries(outputDictionariesList);
	};

	const onCloseDialog = () => {
		setOpenDialog(false);
	};

	useEffect(() => {
		setupDictionaries();
	}, []);

	return (
		<Grid
			size="grow"
			sx={{
				flexBasis: "100%",
				minWidth: "100%"
			}}
		>
			<MDTypography variant="caption" mb={1}>
				{label}
			</MDTypography>
			<MDBox display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
				<MDInput
					disabled
					fullWidth
					value={value}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<Tooltip placement="top" title={t("SETTINGS.DICTIONARY.copyToClipboard")}>
									<IconButton
										color="info"
										style={{ pointerEvents: "visible" }}
										onClick={() => {
											navigator.clipboard.writeText(value);
										}}
									>
										<Icon>copy</Icon>
									</IconButton>
								</Tooltip>
							</InputAdornment>
						)
					}}
				/>
				<MDButton
					disabled={disabled}
					sx={{ ml: 1 }}
					variant="contained"
					color="info"
					onClick={() => setOpenDialog(true)}
				>
					{t("SETTINGS.edit")}
				</MDButton>
			</MDBox>
			<MappingDialog
				open={openDialog}
				onClose={onCloseDialog}
				mapping={value}
				config={{
					dictionariesInput: inputDictionaries,
					dictionariesOutput: outputDictionaries
				}}
				onChange={onChange}
			/>
		</Grid>
	);
};

export default InputMapping;
